module.exports = __webpack_public_path__ + "img/whatsapp.c73eb2b3.png";